import { Grid, styled } from "@mui/material";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";

export const FieldsGrid = styled(Grid)(() => ({
  height: "100%",
  width: "100%",
}));

export const Label = styled("label")(() => ({
  marginBottom: "0px",
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: 0.1,
  color: "#0055A4",
  "& > span": {
    color: "#f04438",
  },
}));

const styles = makeStyles<Theme>((theme) => ({
  modalWidth: {
    width: "45vw",
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  sectionWidth: {
    width: "100%",
  },
  skeletonWidth: {
    width: "100%",
  },
}));

export default styles;
